export var emtyValueFill = function (val, length, fill) {
    if (length === void 0) { length = 3; }
    if (fill === void 0) { fill = '0'; }
    return !val
        ? fill.repeat(length)
        : (fill + val || '').slice((val || '').toString().length < length ? -1 * (length + (val || '').toString().length) : 1);
};
